import { Injectable } from '@angular/core';
import { HttpParams, HttpResponse } from '@angular/common/http';
import { UserListItem } from '../models/user-list.model';
import { UserService } from './user.service';
import { UserCriteria } from '../models/user.criteria';
import { EntityListResolver } from 'src/app/core/services/entity-list.resolver';


@Injectable({ providedIn: 'root' })
export class UserListResolver extends EntityListResolver<UserService, UserListItem, UserCriteria> {
  constructor(
    userService: UserService
  ) {
    super(userService, new UserCriteria());
  }
}
